import { ReportStatsComponent } from './report-stats.component';

export default angular
  .module('sfMobile.components.report-stats', [
    'sfMobile.services.forms',
    'sfMobile.components.content',
    'sfMobile.components.button-selector',
  ])
  .component('sfReportStats', ReportStatsComponent).name;
